var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0733471 5.81248C0.0915031 5.74894 0.0720806 5.68114 0.110291 5.62292L3.10009 1.08701C3.54762 0.408079 4.30187 0 5.10936 0H11.8905C12.6982 0 13.452 0.407685 13.8998 1.08701L16.8898 5.62292C16.928 5.68092 16.9086 5.74915 16.9267 5.81269L17 5.99116V9.56201C16.9998 10.9087 15.9196 11.9996 14.5863 12H2.41393C1.08061 11.9994 0.000642776 10.9087 0.000211716 9.56201L0 5.99116L0.0733471 5.81248ZM12.804 1.82395C12.6007 1.5152 12.2576 1.32991 11.8905 1.32991H5.10938C4.74228 1.32991 4.39944 1.51541 4.19597 1.82395L1.88715 5.32635H4.63906C5.55334 5.32635 6.43362 5.83893 6.82288 6.72935C7.10576 7.38202 7.74959 7.83895 8.49985 7.8383C9.25011 7.83915 9.89375 7.38221 10.1768 6.72935C10.5661 5.83895 11.4462 5.32656 12.3606 5.32635H15.1123L12.804 1.82395ZM1.31631 9.56248C1.31757 10.1742 1.80775 10.6695 2.41341 10.6706H14.5858C15.1916 10.6693 15.6818 10.1742 15.6831 9.56248V6.65648H12.3602C11.9261 6.65648 11.5333 6.90403 11.383 7.26204C10.8987 8.38426 9.7894 9.16783 8.49958 9.16848C7.20998 9.16784 6.10024 8.38404 5.61619 7.26204C5.46589 6.90447 5.07301 6.65648 4.639 6.65648H1.31652L1.31631 9.56248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveTransparent);
export default __webpack_public_path__ + "static/media/ArchiveTransparent.576dfb0290d81e9184c90bf01a557c44.svg";
export { ForwardRef as ReactComponent };